import { render, staticRenderFns } from "./ViewNotificationPage.vue?vue&type=template&id=1e88c77c"
import script from "./ViewNotificationPage.vue?vue&type=script&lang=js"
export * from "./ViewNotificationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports